// DestinationNav.js
import { defineComponent } from "/Scripts/vue.esm-browser.js";
const html = String.raw;

export default defineComponent({
  name: "DestinationNav",
  props: {
    deptInfo: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  inject: [],
  emits: [],
  setup(props, { emit }) {},
  template: html`
    <a
      v-if="deptInfo"
      :class="'nav-link nav-link-'+index"
      :href="'/Promotions/ClearanceSale/清艙快閃王?dept='+deptInfo.key"
    >
      <div>
        <div class="text">{{deptInfo.text}}</div>
        <div class="text">出發行程</div>
        <div class="button-icon-plane">
          <img
            src="/action/theme/clearanceSale/V2/images/kv/icon-plane.png"
            alt=""
          />
          <div class="line"></div>
        </div>
      </div>
      <p>{{deptInfo.p}}</p>
    </a>
  `,
  methods: {},
});
